import { render, staticRenderFns } from "./AutorizeModel.vue?vue&type=template&id=2d2ef88e"
import script from "./AutorizeModel.vue?vue&type=script&lang=js"
export * from "./AutorizeModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports